import './_static/App.css';
import React from "react";
import {RouterProvider} from "react-router-dom"
import getRouter from "./router";


function App() {
    const router = getRouter();

    return (
        <div className="App">
            {/*<React.StrictMode>*/}
            <RouterProvider router={router}></RouterProvider>
            {/*</React.StrictMode>*/}
        </div>

    );
}

export default App;
